import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";

export default function FeaturedSection() {
  const featured = videos.filter((v) => v.rating >= 9.3).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            编辑推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
            精选高分影视作品，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-xl mb-3">
                <img
                  src={video.coverImage}
                  alt={`${video.title} - 玫瑰视频高清在线观看`}
                  title={`${video.title} - 玫瑰视频`}
                  className="w-full aspect-video object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded-md">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-3 mt-1.5">
                <span className="text-xs text-foreground-400">{video.source}</span>
                <span className="text-xs text-foreground-300">·</span>
                <span className="text-xs text-foreground-400">{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}